import React from 'react';
import {
  StyledModal,
  Title,
  ParticipantList,
  ParticipantItem,
  CloseButton
} from '../styles/chatStyles2'; // Ajusta la ruta si es distinta

const GroupParticipantsModal = ({ isOpen, onClose, participants, groupName }) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Participantes del grupo"
      overlayClassName="ReactModal__Overlay"
      ariaHideApp={false}
    >
      <Title>Participantes de {groupName}</Title>
      <ParticipantList>
        {participants.map(user => (
          <ParticipantItem key={user.user_id || user.id}>
            {user.name || `ID ${user.user_id}`}
          </ParticipantItem>
        ))}
      </ParticipantList>
      <CloseButton onClick={onClose}>Cerrar</CloseButton>
    </StyledModal>
  );
};

export default GroupParticipantsModal;
